import React, { useCallback, useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import { Button, Divider, IconButton, List, ListItem, ListItemButton, Paper, TextField, Typography } from '@mui/material';
import { Folder, Home, InsertDriveFile as File, FolderOutlined, Refresh, Upload, CreateNewFolder, CreateNewFolderOutlined, FileUpload, FileUploadOutlined } from '@mui/icons-material'
import { useDropzone } from 'react-dropzone'
import { Sidebar } from "./sidebar";
import { Header } from "./header";
import { FileItem } from "./file-item";

export interface ExplorableFile {
  name: string;
  path: string;
  size: number;
  lastModified: Date;
  children?: ExplorableFile[]
}

export interface FileExplorerProps {
  onRefresh?: (path: string) => void;
  onUpload?: (file: any[], prefix?: string) => void;
  files: ExplorableFile[];

  path: string;
  onNavigate?: (path: string) => void;
}

const Root: React.FC<FileExplorerProps> = (props) => {

  const onDrop = useCallback((files: any[]) => {
    props.onUpload?.(files, props.path)
  }, [props.path]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    noClick: true
  })



  const [selected, setSelected] = useState<any[]>([]);

  //   {
  //     name: "Documents",
  //     isDirectory: true, // Folder
  //     path: "/Documents", // Located in Root directory
  //     updatedAt: "2024-09-09T10:30:00Z", // Last updated time
  //   },
  //   {
  //     name: "Pictures",
  //     isDirectory: true,
  //     path: "/Pictures", // Located in Root directory as well
  //     updatedAt: "2024-09-09T11:00:00Z",
  //   },
  //   {
  //     name: "Pic.png",
  //     isDirectory: false, // File
  //     path: "/Pictures/Pic.png", // Located inside the "Pictures" folder
  //     updatedAt: "2024-09-08T16:45:00Z",
  //     size: 2048, // File size in bytes (example: 2 KB)
  //   },
  // ]);

  // useEffect(() => {
  //   props.onRefresh?.(path);
  // }, [path])

  const onItemClick = (e: any, file: any) => {
    if (selected.indexOf(file.path) > -1) {

    } else {
      if (e.ctrlKey || e.metaKey) {
        setSelected((s) => s.concat([file.path]))
      } else {
        setSelected([file.path])
      }
    }
  }

  const onItemDblClick = (e: any, file: any) => {
    console.log("Double click")
    props.onNavigate?.('/' + file.path)
  }

  const activeFiles = useMemo(() => {
    let parts = props.path?.split('/')?.filter((a) => a.length != 0);

    console.log({ path: props.path })

    const files = parts.reduce((prev: any, curr: any) => {
      let next = prev?.find((a) => a.name == curr);
      return next?.children || next;
    }, props.files)

    return (files || []);
  }, [props.path, props.files]);

  return <Paper style={{
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    color: 'black'
  }}>
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex' }}>
        <Button sx={{ color: 'black', fontWeight: 'normal', textTransform: 'none' }}><CreateNewFolderOutlined sx={{ marginRight: '8px' }} /> New folder</Button>
        <Button sx={{ color: 'black', fontWeight: 'normal', textTransform: 'none' }}><FileUploadOutlined sx={{ marginRight: '8px' }} />Upload</Button>
      </div>

      <div>
        <Button sx={{ color: 'black' }}><Refresh /></Button>
      </div>
    </div>
    <Divider />
    <div style={{ display: 'flex', flex: 1 }}>
      <div style={{ width: '200px' }}>
        {/*Sidebar*/}
        <Sidebar
          onNavigate={props.onNavigate}
          files={activeFiles?.filter((a) => a.children)} />
      </div>
      <Divider orientation="vertical" />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Header
          onNavigate={props.onNavigate}
          chain={props.path?.split('/').slice(1, props.path?.split('/')?.length).filter((a) => a.length != 0)} />
        <Divider />
        <div {...getRootProps()} style={{
          flex: 1,
          borderRadius: '5px',
          border: isDragActive ? '1px solid blue' : undefined
        }}>
          <input {...getInputProps()} />
          {/*Body*/}
          <List>
            {activeFiles?.map((file) => {
              return (
               <FileItem
                key={file.path}
                file={file}
                isDirectory={file.children}
                selected={selected?.indexOf(file.path) > -1}
                  onDoubleClick={(e) => onItemDblClick(e, file)}
                  onItemClick={(e) => onItemClick(e, file)}
                  onUpload={(files) => {
                    props.onUpload?.(files, '/' + file.path)
                  }}
                />
              )
            })}
          </List>
        </div>
      </div>
    </div>
    {/* <FileManager 
        initialPath={props.path || path}
        onFileOpen={(file) => {
          if(file.isDirectory){
            // setPath(file.path)
            props.onPathChange?.(file.path);
          }
        }}
        onCreateFolder={(name: string, parentFolder: any) => {
          const newFolder = (parentFolder ? parentFolder.path + '/' : '') + name;
          console.log({newFolder})
          props.onCreateFolder?.(newFolder)
        }}
        onRefresh={() => {
          props.onRefresh?.(path);
        }}
        onFileUploading={(file, parentFolder) => {
          props.onUpload?.(file, parentFolder)
        }}
        filePreviewPath={'https://preview.hexhive.io'}
        files={props.files || []} /> */}
  </Paper>;
}

export default Root;